import { render, staticRenderFns } from "./ReglaArticulo.vue?vue&type=template&id=047c5aa4&"
import script from "./ReglaArticulo.vue?vue&type=script&lang=js&"
export * from "./ReglaArticulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports